import { NumberInput, required, SelectInput, SimpleForm, TextInput } from "react-admin";
import { packetTypeChoices, tiTypeChoices } from "shared/enums/reactAdminChoices";

const RteCommunicationConfigCreate = () => {
  return (
    <SimpleForm>
      <NumberInput source="ioa" validate={[required()]} />

      <TextInput source="code_tm" validate={[required()]} />
      <SelectInput source="packet_type" choices={packetTypeChoices} validate={[required()]} />
      <SelectInput source="telemetry_field_name" choices={tiTypeChoices} validate={[required()]} />
    </SimpleForm>
  );
};

export default RteCommunicationConfigCreate;
